import type { OrderEventInternalNoteRead } from '@klear/order-event/order-event-internal-note.wire'
import { Timestamp } from '@klear/time'
import { trpc } from '@klear/ui/lib/trpc'
import type { RejectableField } from '@/app/receivables/reject-dialog'

const WRITTEN_AT_FORMAT = 'MMM D, YYYY h:mma'

export function InternalNoteList({
  notes,
  fields
}: {
  notes: readonly OrderEventInternalNoteRead[]
  fields: readonly RejectableField[]
}) {
  if (notes.length === 0) return null
  return (
    <section aria-label="Internal notes" className="grid gap-2">
      <div>
        <h4 className="text-sm font-semibold">Internal notes</h4>
        <p className="text-xs text-muted-foreground">Klear only. The trader never sees these.</p>
      </div>
      <ul className="grid gap-2">
        {notes.map((note) => (
          <li key={note.id} className="grid gap-1 rounded-md border p-3 text-sm">
            <div className="flex flex-wrap items-baseline justify-between gap-x-2 text-xs text-muted-foreground">
              <span className="font-medium text-foreground">
                {fields.find((field) => field.key === note.field)?.label ?? note.field}
              </span>
              <span>
                {note.createdByName ?? `User ${note.createdBy}`} ·{' '}
                {Timestamp.fromEpochMs(note.createdAt).toLocalString(WRITTEN_AT_FORMAT)}
              </span>
            </div>
            <p className="whitespace-pre-wrap break-words">{note.note}</p>
          </li>
        ))}
      </ul>
    </section>
  )
}

export function InternalNotes({ orderEventId, fields }: { orderEventId: number; fields: readonly RejectableField[] }) {
  const { data } = trpc.orderEvent.listInternalNotes.useQuery({ orderEventId })
  return <InternalNoteList notes={data?.notes ?? []} fields={fields} />
}
